import { html, css, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import { OmegaComponent } from '@omegagrid/core';
import { msg } from '@omegagrid/localize';
import rp from '@reporting/rp-app-host';
import { formatDateTime } from '../formatters';

/**
 * The latest alerts of the bucket (newest first), see `BucketAlerts.history`: the user gets back to a message that
 * closed or timed out before they noticed it. Opened from the help menu, rendered in a dialog.
 */
@customElement('rp-app-alert-history')
export class AlertHistory extends OmegaComponent {

	static styles = [OmegaComponent.styles, css`
		:host {
			display: flex;
			flex-direction: column;
			gap: 8px;
			padding: 8px;
			font-size: var(--og-font-size);
		}

		.toolbar {
			display: flex;
			justify-content: flex-end;
		}

		.item {
			display: flex;
			flex-direction: column;
			gap: 2px;
		}

		.time {
			opacity: 0.7;
			font-size: 0.9em;
		}

		.empty {
			opacity: 0.7;
			padding: 10px;
			text-align: center;
		}
	`];

	private get alerts() { return rp.host?.bucket?.alerts }

	private _onChange = () => this.requestUpdate();

	connectedCallback() {
		super.connectedCallback();
		rp.host?.bucket?.addEventListener('alerts.change', this._onChange);
	}

	disconnectedCallback() {
		super.disconnectedCallback();
		rp.host?.bucket?.removeEventListener('alerts.change', this._onChange);
	}

	render = () => {
		const items = this.alerts?.history ?? [];
		return html`
			${items.length ? html`
				<div class="toolbar">
					<og-button
						text="${msg('Clear')}"
						icon="trash"
						color="transparent"
						@click="${() => this.alerts.clearHistory()}">
					</og-button>
				</div>
			` : nothing}

			${items.length ? items.map(item => html`
				<div class="item">
					<span class="time">${formatDateTime(item.time)}</span>
					<og-bucket-alert inline nocopy .options="${item.options}"></og-bucket-alert>
				</div>
			`) : html`
				<div class="empty">${msg('No notifications yet')}</div>
			`}
		`;
	}

}
